import "./header.css";
import React, { useState, useEffect } from "react";
import { ReactComponent as Title } from "../../../images/title.svg";
import { ReactComponent as BurgerIcon } from "../../../images/burger-menu.svg";

function MobileHeader() {
  const [top, setTop] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);

  const closeNav = () => setIsNavOpen(false);

  return (
    <header className={`fixed w-full mobile-header-wrapper flex items-center justify-between`}>
      <nav className="flex flex-grow">
        <div className="flex flex-grow justify-start items-center">
          <BurgerIcon onClick={() => setIsNavOpen((prev) => !prev)} />
          <div className={isNavOpen ? "showMenuNav" : "hideMenuNav"}>
            <div
              className="CROSS-ICON absolute top-0 right-0 px-8 py-8"
              onClick={() => setIsNavOpen(false)} // change isNavOpen state to false to close the menu
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>
            <ul className="MENU-LINK-MOBILE-OPEN flex flex-col items-center justify-between min-h-[250px]">
              <a
                href="#demo"
                className="lg:text-xl 2xl:text-2xl font-medium text-neutral-800 hover:text-violet-600 px-5 py-3 flex items-center transition duration-150 ease-in-out"
                onClick={closeNav}
              >
                Demo
              </a>
              <a
                href="#roadmap"
                className="lg:text-xl 2xl:text-2xl font-medium text-neutral-800 hover:text-violet-600 px-5 py-3 flex items-center transition duration-150 ease-in-out"
                onClick={closeNav}
              >
                Roadmap
              </a>
              <a
                href="#footer"
                className="lg:text-xl 2xl:text-2xl font-medium text-neutral-800 hover:text-violet-600 px-5 py-3 flex items-center transition duration-150 ease-in-out"
                onClick={closeNav}
              >
                Join us
              </a>
            </ul>
          </div>
        </div>
      </nav>
      <div className="flex items-center">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mobile-logo-icon"
        >
          <g clip-path="url(#clip0_901_105)">
            <path
              d="M31.9931 20.5106C31.9519 21.7126 31.7098 22.9308 31.2217 24.0236C28.3246 30.5226 17.0769 30.0659 14.0762 29.9442C9.84477 29.7711 3.42639 29.5101 1.03734 25.0712C0.656781 24.3471 0.383449 23.571 0.225996 22.7675C0.152697 22.4038 0.0985205 22.0365 0.0636933 21.6672C-0.0690932 20.3151 0.0507304 18.9501 0.416991 17.6423C0.436911 17.5721 0.458133 17.5018 0.479241 17.4328C0.673593 16.791 0.946106 16.1758 1.29059 15.6012C3.14807 12.5537 4.3139 11.4233 4.3139 11.4233C4.94303 10.8123 5.9753 9.93024 6.23987 8.52628C6.33899 8.04848 6.33986 7.55535 6.24241 7.07721C6.02895 6.07347 5.51341 5.96687 5.28252 5.14254C4.99169 4.1062 5.35863 2.68347 6.24864 2.24434C6.8403 1.95203 7.4993 2.18035 7.69029 2.24685C9.0646 2.71982 9.147 3.94312 10.0919 4.18277C10.2978 4.23834 10.5164 4.22242 10.7123 4.1376C11.2752 3.90296 11.7745 3.17903 12.8667 2.63199C12.8757 2.62936 12.8841 2.62512 12.8916 2.61948C12.9728 2.58182 13.0576 2.54292 13.145 2.50407C13.6309 2.29791 14.141 2.15496 14.6629 2.0787C15.7602 1.91013 16.8818 2.0091 17.9332 2.36726C18.3763 2.51985 18.797 2.73171 19.1839 2.99712C20.3135 3.77999 20.346 4.65199 21.1498 4.67957C22.2107 4.71473 22.5702 3.24928 24.2566 3.00338C24.5637 2.96071 25.1803 2.87789 25.7058 3.24797C26.1214 3.54034 26.4734 4.1012 26.4385 4.68708C26.3823 5.64839 25.3288 5.81904 24.993 7.10099C24.8926 7.49792 24.8756 7.91156 24.9431 8.31547C25.0929 9.3154 25.7207 10.0418 26.24 10.4835C26.4498 10.6641 26.6745 10.8265 26.9116 10.969C26.9116 10.969 28.191 11.9138 29.7513 13.9275C30.0758 14.3465 30.4128 14.8107 30.7524 15.3226C31.3013 16.1544 31.6985 17.2861 31.8832 18.5345C31.9799 19.1884 32.0166 19.8499 31.9931 20.5106Z"
              fill="#B09EE6"
            />
            <path
              d="M31.9933 20.5106C31.9521 21.7126 31.7099 22.9308 31.2218 24.0236C28.3248 30.5226 17.077 30.0659 14.0763 29.9442C9.84491 29.7711 3.42653 29.5101 1.03749 25.0712C0.507003 24.0838 0.179907 22.9006 0.0641217 21.6673C-0.0767705 20.2421 0.0645001 18.803 0.479783 17.433C0.674134 16.7912 0.946648 16.176 1.29113 15.6014C3.14822 12.5537 4.31405 11.4233 4.31405 11.4233C4.94317 10.8123 5.97545 9.93024 6.24001 8.52628C6.33914 8.04848 6.34 7.55535 6.24256 7.07721C6.0291 6.07347 5.51355 5.96687 5.28266 5.14254C4.99184 4.1062 5.35878 2.68347 6.24878 2.24434C6.84044 1.95203 7.49944 2.18035 7.69044 2.24685C9.06475 2.71982 9.14715 3.94312 10.092 4.18277C10.298 4.23834 10.5166 4.22242 10.7124 4.1376C11.2754 3.90296 11.7747 3.17903 12.8668 2.63199C12.8758 2.62936 12.8843 2.62512 12.8918 2.61948C12.9729 2.58182 13.0578 2.54292 13.1452 2.50407C13.6311 2.29791 14.1411 2.15496 14.663 2.0787C15.7604 1.91013 16.882 2.0091 17.9334 2.36726C13.5435 3.63926 10.3271 7.0734 9.67389 11.1648C9.66727 11.2061 9.65794 11.2649 9.64707 11.3395C9.28178 13.8598 9.89041 17.2837 12.0455 19.4452C15.0502 22.4594 19.7316 21.6787 20.2837 21.5783C24.9451 20.7285 26.7219 16.8791 29.3957 17.6888C30.74 18.0961 31.5344 19.4456 31.9933 20.5106Z"
              fill="#6E4CD1"
            />
            <path
              d="M31.9932 20.5107C31.952 21.7127 31.7098 22.9309 31.2217 24.0237C28.3247 30.5227 17.0769 30.066 14.0762 29.9443C9.91205 29.7754 3.57567 29.5139 1.0374 25.0713C-0.0442849 23.1782 -0.0861623 21.1379 0.0625023 19.6964C9.29815 25.8162 19.4329 25.1207 23.7787 19.9474C26.3039 16.9413 26.4404 12.9399 26.2401 10.4836C26.4499 10.6643 26.6746 10.8267 26.9117 10.9692C26.9117 10.9692 28.1911 11.9139 29.7514 13.9276C30.0759 14.3467 30.4129 14.8109 30.7525 15.3228C31.3014 16.1546 31.6986 17.2863 31.8833 18.5347C31.9799 19.1886 32.0167 19.85 31.9932 20.5107Z"
              fill="#4931AD"
            />
          </g>
          <defs>
            <clipPath id="clip0_901_105">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <Title  />
      </div>
    </header>
  );
}

export default MobileHeader;
